<template>
  <div class="box">
    <div ref="top" class="top">
      <v-top-title :title="title"></v-top-title>
    </div>
    <el-row ref="content" class="content">
      <slot name="content" />
    </el-row>
    <el-row
      ref="table"
      class="table"
      :style="{ height: 'calc(100% - ' + height + 'px)' }"
    >
      <slot name="table" />
    </el-row>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, nextTick } from "vue";

interface Props {
  title: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: "",
});

const top = ref();
const table = ref();
const content = ref();

// 表格高度
const height = ref();
onMounted(() => {
  nextTick(() => {
    height.value =
      (top.value?.offsetHeight || 0) + (content.value?.$el?.offsetHeight || 0);
  });
});
</script>
<style lang="scss" scoped>
.box {
  height: 100%;
}
.content,
.table {
  width: 100%;
  background-color: #fff;
  padding: 0 24px;
  box-sizing: border-box;
}
.top {
  width: 100%;
}
</style>
